import { render, staticRenderFns } from "./orderDistribute.vue?vue&type=template&id=e8dba59e&"
import script from "./orderDistribute.vue?vue&type=script&lang=js&"
export * from "./orderDistribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports